import { useEffect } from 'react';

const handleIntersections = (
  entries: IntersectionObserverEntry[],
  observer: IntersectionObserver,
  callback: () => void,
  target: HTMLElement
) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      callback();
      observer.unobserve(target);
    }
  });
};

/**
 * Per default the intersectionObserver starts half a viewport height before
 * intersecting with the element to give the asset time to load.
 */
export const useInitialIntersection = (
  elementRef: React.RefObject<HTMLElement>,
  callback: () => void,
  margin = `50%`
) => {
  useEffect(() => {
    const target = elementRef.current;

    if (target) {
      const intersectionObserver = new IntersectionObserver(
        (entries, observer) => handleIntersections(entries, observer, callback, target),
        { root: null, rootMargin: margin, threshold: 0 }
      );

      intersectionObserver.observe(target);

      return () => intersectionObserver.unobserve(target);
    }
    // elementRef is a ref and can be omitted
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback, margin]);
};
